module.exports = __webpack_public_path__ + "img/mag-3.d8a2e494.jpg";